import { FETCH_LOCKERS_REQUEST, FETCH_LOCKER_DETAIL_REQUEST } from './types'
import { takeLatest } from 'redux-saga/effects'
import { fetchLockerDetailSaga } from './sagas'

// export function* watchLockersSaga() {
//   yield takeLatest(FETCH_LOCKERS_REQUEST, fetchLockersSaga)
// }

export function* watchLockerDetailSaga() {
  yield takeLatest(FETCH_LOCKER_DETAIL_REQUEST, fetchLockerDetailSaga)
}
